/** Re-exports the auto-generated types and defines additional content that should not get overwritten when types are generated. */

import {
  CURRENCIES,
  Currency,
  CurrencyMinorUnits,
  CurrencyNames,
  isCurrency,
} from "./iso4217/currencies";
import type { OpenExchangeRatesCurrency } from "./openexchangerates.org/currencies";

// Re-export these for external use
export { CURRENCIES, Currency, CurrencyMinorUnits, CurrencyNames, isCurrency };

/**
 * Currencies we will support in our apps. Inherits from the currencies supported by the OpenExchangeRates API.
 * We can use this to carefully and incrementally adopt more currencies over time.
 * Be very careful when removing currencies from here - if any Money objects are stored in the database with
 * the removed currency, they will throw "Invalid currency" errors when loaded.
 */
export type SupportedCurrency = (typeof SUPPORTED_CURRENCIES)[number];

/**
 * List of currencies we supported in our apps
 * @see SupportedCurrency
 */
export const SUPPORTED_CURRENCIES = [
  Currency.USD,
  Currency.CAD,
  Currency.GBP,
  Currency.AUD,
] satisfies OpenExchangeRatesCurrency[];
const SUPPORTED_CURRENCIES_SET = new Set(SUPPORTED_CURRENCIES);

/** @returns Whether the given string is a supported currency code */
export function isSupportedCurrency(code: string): code is SupportedCurrency {
  return (SUPPORTED_CURRENCIES_SET as Set<string>).has(code);
}

/** @returns The symbol for the given currency (ex: $ for USD) */
export function getCurrencySymbol(currency: Currency): string {
  return (0)
    .toLocaleString(undefined, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
}
